import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 ${dark ? 'bg-navy text-cream' : 'bg-cream text-charcoal'} ${className}`} data-id="element-150">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-151">
        {children}
      </motion.div>
    </section>;
}
export function Divider() {
  return <div className="flex justify-center items-center py-12" data-id="element-152">
      <div className="w-16 h-px bg-gold/50" data-id="element-153"></div>
      <div className="w-2 h-2 rounded-full bg-gold mx-4" data-id="element-154"></div>
      <div className="w-16 h-px bg-gold/50" data-id="element-155"></div>
    </div>;
}